import React, { useContext } from 'react';
import { string, arrayOf, shape } from 'prop-types';
import {
  Typography,
  Card,
  CardActions,
  CardMedia,
  Link,
  CardTitle,
  CardBody,
  CardContent,
} from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';

export const ShopByRoomSection = React.memo(({ shopByRoom }) => {

  const { channel } = useContext(ExperienceContext);
  const STYLE_KEY = 'style';
  const ROOM_KEY = 'room';
  const isMobile = channel === 'mobile';

  const routeToCollection = (newUrl) => {
    window.open(`${window.location.origin}${newUrl}`, isMobile ? '_self' : '_blank');
  };

  const clearAndUpdateURL = (filter) => {
    let formattedFilter = filter[0].replace(' ', '-').toLowerCase();
    return formattedFilter;
  };

  return (
    <>
      <div className="sui-pb-4">
        <Typography variant="h2">Shop by Room</Typography>
      </div>
      <div className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2 md:sui-grid-cols-3 sui-gap-4">
        {shopByRoom?.map((SBRCollection) => {
          const url = SBRCollection?.url;
          const imageUrl = SBRCollection?.metadata?.imageUrl;
          const name = SBRCollection?.metadata?.name;
          const style = SBRCollection?.metadata?.style;
          const room = SBRCollection?.metadata?.room;
          let selectables = {};
          if (style) {
            style.forEach((element) => {
              selectables[element] = STYLE_KEY;
            });
          }

          if (room) {
            room.forEach((element) => {
              selectables[element] = ROOM_KEY;
            });
          }

          const lastElement = Object.keys(selectables).length - 1;

          return (
            <div
              key={`sbr-${name}`}
              className="sui-paper sui-paper-outlined sui-rounded-base sui-flex sui-rounded-md"
            >
              <Card>
                <CardMedia
                  src={imageUrl}
                  alt={`${name} Image`}
                  aspect="wide"
                  onClick={() => routeToCollection(url)}
                  loading="lazy"
                />
                <CardTitle
                  header={(
                    <Link href={url} underline="hover" target={isMobile ? '_self' : '_blank'}>
                      <Typography component="h4" variant="h4" weight="bold">{name}</Typography>
                    </Link>
                  )}
                />
                <CardContent grow disablePadding disableGutters>
                  <CardBody />
                  <CardActions>
                    {Object.entries(selectables).map((filter, index) => {
                      const link = clearAndUpdateURL(filter);
                      return (
                        <span key={filter}>
                          <Link
                            target={isMobile ? '_self' : '_blank'}
                            href={`/room/${link}`}
                            color="subtle"
                            underline="always"
                          >
                            {filter[0]}
                          </Link>
                          {index !== lastElement && (
                            <span className="sui-px-1">|</span>
                          )}
                        </span>
                      );
                    })}
                  </CardActions>
                </CardContent>
              </Card>
            </div>
          );
        })}
      </div>
    </>
  );
});

ShopByRoomSection.propTypes = {
  shopByRoom: arrayOf(shape({
    url: string,
    metadata: shape({
      imageUrl: string,
      name: string,
      style: arrayOf(string),
      room: arrayOf(string),
    }),
  })).isRequired,
};
